import {
  FormControl,
  FormGroup,
  InputGroup,
  MenuItem,
  Nav,
  NavDropdown,
  NavItem,
  Navbar
} from "react-bootstrap";
import React, { Component } from "react";

import { FormattedMessage } from "react-intl";
import { LinkContainer } from "react-router-bootstrap";
import { logout } from "../../tools/logout";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";

class HeaderLinks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //            alert: null,
      show: false,
      isOpen: false
    };

    this.hideAlert = this.hideAlert.bind(this);
    this.companySelectAlert = this.companySelectAlert.bind(this);
  }

  hideAlert() {
    console.log("Headerlinks hideAlert");
    this.setState({
      // alert: null,
      isOpen: false
    });
  }

  companySelectAlert() {
    console.log("Headerlinks showAlert");

    this.props.showCompanySwitcher();
    // this.setState({
    //   // alert: null,
    //   isOpen: true
    // });

    //     this.setState({
    //         alert: (
    //             <CompanySwitcher {...this.props} />

    //             // <SweetAlert
    //             //     style={{ width: 1000, display: "block", marginTop: "-100px" }}
    //             //     title="Here's a message!"
    //             //     onConfirm={() => this.hideAlert()}
    //             //     onCancel={() => this.hideAlert()}
    //             //     confirmBtnBsStyle="info"
    //             // ><div>TOTO</div></SweetAlert>
    //         )
    //     });
  }

  render() {
    return (
      <div>
        {/* {this.state.alert} */}
        <Navbar.Form pullLeft className="navbar-search-form">
          <FormGroup>
            <InputGroup>
              <InputGroup.Addon>
                <i className="fa fa-search" />
              </InputGroup.Addon>
              <FormControl type="text" placeholder="Search..." />
            </InputGroup>
          </FormGroup>
        </Navbar.Form>
        <Nav pullRight>
          <NavItem eventKey={3} href="#">
            <i className="fa fa-line-chart" />
            <p>Stats</p>
          </NavItem>
          <NavDropdown
            eventKey={2}
            title={
              <div>
                <i className="fa fa-gavel" />
                <p className="hidden-md hidden-lg">
                  Actionsfalse
                  <b className="caret" />
                </p>
              </div>
            }
            noCaret
            id="basic-nav-dropdown-1">
            <MenuItem eventKey={2.1}>Create New Post</MenuItem>
            <MenuItem eventKey={2.2}>Manage Something</MenuItem>
            <MenuItem eventKey={2.3}>Do Nothing</MenuItem>
            <MenuItem eventKey={2.4}>Submit to live</MenuItem>
            <MenuItem divider />
            <MenuItem eventKey={2.5}>Another action</MenuItem>
          </NavDropdown>
          <NavDropdown
            eventKey={3}
            title={
              <div>
                <i className="fa fa-bell-o" />
                <span className="notification">5</span>
                <p className="hidden-md hidden-lg">
                  Notifications
                  <b className="caret" />
                </p>
              </div>
            }
            noCaret
            id="basic-nav-dropdown-2">
            <MenuItem eventKey={3.1}>Notification 1</MenuItem>
            <MenuItem eventKey={3.2}>Notification 2</MenuItem>
            <MenuItem eventKey={3.3}>Notification 3</MenuItem>
            <MenuItem eventKey={3.4}>Notification 4</MenuItem>
            <MenuItem eventKey={3.5}>Another notifications</MenuItem>
          </NavDropdown>
          <NavDropdown
            eventKey={4}
            title={
              <div>
                <i className="fa fa-list" />
                <p className="hidden-md hidden-lg">
                  More
                  <b className="caret" />
                </p>
              </div>
            }
            noCaret
            id="basic-nav-dropdown-3"
            bsClass="dropdown-witshowh-icons dropdown">
            <MenuItem eventKey={4.1}>
              <i className="pe-7s-mail" />
              Messages
            </MenuItem>
            <MenuItem eventKey={4.2}>
              <i className="pe-7s-help1" />
              Help Center
            </MenuItem>
            <MenuItem eventKey={4.3}>
              <i className="pe-7s-tools" />
              Settings
            </MenuItem>
            <MenuItem eventKey={4.4}>
              <LinkContainer to="/companies">
                <div>
                  <i className="pe-7s-close-circle" />
                  <FormattedMessage id={"ids_switchCompany"} />
                </div>
              </LinkContainer>

              {/* <div onClick={this.companySelectAlert.bind(this)}> */}
            </MenuItem>
            <MenuItem eventKey={4.5}>
              <LinkContainer to="/plans">
                <div>
                  <i className="pe-7s-cart" />
                  <FormattedMessage id={"ids_plans"} />
                </div>
              </LinkContainer>
            </MenuItem>

            <MenuItem divider />
            <MenuItem eventKey={4.6}>
              <i className="pe-7s-lock" />
              Lock Screen
            </MenuItem>
            <MenuItem eventKey={4.7}>
              <div className="text-danger" onClick={this._logout}>
                <i className="pe-7s-close-circle" />
                Log out
              </div>
            </MenuItem>
          </NavDropdown>
        </Nav>
      </div>
    );
  }

  _logout = () => {
    logout();
  };
}
export default withRouter(withApollo(HeaderLinks));
